import React, {useEffect, useState} from 'react';
import axios from "axios";
import {useStores} from "../../../../stores/Context";
import {useParams} from "react-router-dom";
import moment from "moment";
import 'moment/locale/fr';
import WidgetConsignesContentModify from "./WidgetConsignesContentModify";
import WidgetConsignesContentZoom from "./WidgetConsignesContentZoom";
import WidgetConsignesContentAdd from "./WidgetConsignesContentAdd";
import WidgetConsignesContentHistory from "./WidgetConsignesContentHistory";
import {observer} from "mobx-react";
import WidgetConsignesContentParametres from "./WidgetConsignesContentParametres";
import WidgetConsignesContentPhoto from "./WidgetConsignesContentPhoto";
import ModalPrimary from "../../../../boiteAOutils/ModalPrimary";
import Checkbox from "../../../../boiteAOutils/Checkbox";
import CrayonSvg from "../../../../boiteAOutils/SVG/CrayonSvg";
import CorbeilleSvg from "../../../../boiteAOutils/SVG/CorbeilleSvg";
import BtnSvg from "../../../../boiteAOutils/BtnSvg";
import Pusher from "pusher-js";
import Echo from "laravel-echo";


const WidgetConsignesContentHome = observer(() => {
    const {id, ent} = useParams();
    moment.locale('fr');
    const {widgetStore, consignesStore} = useStores();
    const [isLoad, setIsLoad] = useState(false);
    const [listConsignes, setListConsignes] = useState([]);
    const [showElements, setShowElements] = useState([]);
    const [countFav, setCountFav] = useState('');
    const [showModifyConsigneData, setShowModifyConsigneData] = useState('')
    const [showZoomConsigne, setShowZoomConsigne] = useState('');
    const [showArchiveConsigne, setShowArchiveConsigne] = useState({isOpen: false, idConsigne: '', indexConsigne: ''});
    const [showModalEpingle, setShowModalEpingle] = useState(false);

    const handleBtnViewPhoto = () => {
        consignesStore.handleViewPhoto()
    }


    /*
    * Soketi
    */
    window.Pusher = Pusher;

    useEffect(() => {
        const echo = new Echo({
            broadcaster: 'pusher',
            key: process.env.REACT_APP_WS_KEY,
            secret: process.env.REACT_APP_WS_SECRET,
            wsHost: process.env.REACT_APP_WS_URL,
            wsPort: 6001,
            forceTLS: true,
            encrypted: true,
            disableStats: true,
            enabledTransports: ['ws', 'wss'],
            cluster: 'eu',
        });

        const connectionEvents = ['connected', 'disconnected', 'connecting', 'reconnecting', 'error'];
        connectionEvents.forEach(event => {
            echo.connector.pusher.connection.bind(event, (err) => {
                console.log(`Consigne_WS::${event}`);
            });
        });

        // Evenement pour mettre à jour la liste des messages interne + messages archivé.
        echo.channel(widgetStore.idTotem + '-Consigne_refreshDatas')
            .listen('Consignes\\ConsigneRefreshEvent', (e) => {
                axios.get(process.env.REACT_APP_API_URL + '/api/allConsignesByIdTotem/' + widgetStore.idTotem,
                    {headers: {"Authorization": `Bearer ${widgetStore.getCookie("current_apiToken")}`}}
                ).then((res) => {
                    setListConsignes(res.data)
                    const nbrFavoris = res.data.filter(item => item.consigne.favoris === 1);
                    setCountFav(nbrFavoris.length)
                    setIsLoad(false)
                });
            });


        // Cleanup function to unsubscribe when the component unmounts
        return () => {
            echo.disconnect();
        };
    }, []);

    useEffect(() => {
        axios.get(process.env.REACT_APP_API_URL + '/api/allConsignesByIdTotem/' + widgetStore.idTotem,
            {headers: {"Authorization": `Bearer ${widgetStore.getCookie("current_apiToken")}`}}
        ).then((res) => {
            setListConsignes(res.data)
            const nbrFavoris = res.data.filter(item => item.consigne.favoris === 1);
            setCountFav(nbrFavoris.length)
            setIsLoad(false)
        });
    }, [isLoad])

    const ArchiveConsigne = () => {

        if (showArchiveConsigne.idConsigne) {
            toggleElement(showArchiveConsigne.indexConsigne);

            axios.post(process.env.REACT_APP_API_URL + '/api/archiveConsigne', {
                    id: showArchiveConsigne.idConsigne
                },
                {headers: {"Authorization": `Bearer ${widgetStore.getCookie("current_apiToken")}`}}
            ).then((res) => {
                setShowArchiveConsigne({...showArchiveConsigne, isOpen: false, idConsigne: '', indexConsigne: ''})
                setIsLoad(true)
            })
        }
    }

    const handleZoomConsigne = (data) => {
        setShowModifyConsigneData('');
        setShowZoomConsigne(data)
    }

    const handleCloseUpdateConsigne = () => {
        setShowModifyConsigneData('');
    }

    const handleUpdateconsigne = (data, index) => {
        setShowElements([])

        if (showModifyConsigneData) {
            handleCloseUpdateConsigne()
        }

        setTimeout(function () {
            setShowModifyConsigneData(data)
        }, 100)
    }

    const toggleElement = (index) => {
        setShowElements((prevShowElements) => {
            const newShowElements = [...prevShowElements];
            newShowElements[index] = !newShowElements[index];
            return newShowElements;
        });
    }

    const handleUpdateQuart = (data, value, id_consigne) => {
        let newVal = !value;

        axios.post(process.env.REACT_APP_API_URL + '/api/updateQuartConsignes', {
                id: data.id,
                value: newVal,
                id_consigne: id_consigne
            },
            {headers: {"Authorization": `Bearer ${widgetStore.getCookie("current_apiToken")}`}}
        ).then(() => {
            setIsLoad(true)
        });
    }

    const updateFavoris = (id, val) => {
        axios.post(process.env.REACT_APP_API_URL + '/api/addToFavoris', {
                id_consigne: id,
                favoris: val
            },
            {headers: {"Authorization": `Bearer ${widgetStore.getCookie("current_apiToken")}`}}
        ).then((res) => {
            setIsLoad(true)
        })
    }
    const handleAddFavoris = (id_consigne, value) => {
        let fav = value === 1 ? 0 : 1;

        if (fav === 1) { /// on ajoute la consigne en favoris
            if (countFav < 3) {  /// verification du nbr de consignes déja en fav
                updateFavoris(id_consigne, fav)
            } else {
                setShowModalEpingle(true);
            }
        } else if (fav === 0) { // on retire la consigne des favoris
            updateFavoris(id_consigne, fav)
        }
    }

    return (
        <div className={"ConsignesContent"}>


            {
                showModifyConsigneData ? (
                    <WidgetConsignesContentModify data={showModifyConsigneData} onClose={handleCloseUpdateConsigne}
                                                  onUpdate={() => setIsLoad(true)}/>
                ) : null
            }
            {
                consignesStore.viewAddConsigne ? (
                    <WidgetConsignesContentAdd onClose={() => setIsLoad(true)}/>
                ) : null
            }
            {
                consignesStore.viewParametre ? (
                    <WidgetConsignesContentParametres/>
                ) : null
            }
            {
                consignesStore.viewHistory ? (
                    <WidgetConsignesContentHistory onRestore={() => setIsLoad(true)}/>
                ) : null
            }
            {
                consignesStore.viewPhoto ? (
                    <WidgetConsignesContentPhoto/>
                ) : null
            }

            {
                showZoomConsigne ? (
                    <WidgetConsignesContentZoom data={showZoomConsigne} onClose={() => setShowZoomConsigne('')}/>
                ) : null
            }

            <div className={"ConsignesContentHeader"}>
                <h1 className={"consignesTitle1"}>Consignes</h1>
                {
                    /*
                    <button type={"button"} onClick={handleBtnViewPhoto}>
                    <svg width="22" height="21" viewBox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1.83301 3.83203H20.1663V17.1654H1.83301V3.83203Z" stroke="#002335"
                              strokeWidth="2"/>
                        <path d="M1.83301 16.3333L14.1247 8L20.1663 11.3333" stroke="#002335" strokeWidth="2"/>
                        <circle cx="6.00033" cy="8.0013" r="0.833333" stroke="#002335" strokeWidth="2"/>
                    </svg>
                    Vos photos enregistrées
                </button>
                     */
                }
            </div>

            <div className={"ConsignesContentListe"}>
                {
                    listConsignes.map((data, index) => (

                        <div className={"consigneCard"}>

                            <div className={"consigneCardColor"}
                                 style={{background: `${data.consigne.tag_color ?? null}`}}></div>

                            <div className={"consigneCardContent"}>
                                <div className={"consigneCardContentHeader"}>
                                    <div className={"consigneCardContentCategory"}>{data.consigne.tag_nom ?? null}</div>

                                    <div className={"consigneCardContentActionsMenu"}>
                                        <div className={"consigneCardContentActions"}
                                             onClick={() => toggleElement(index)}>
                                            <svg width="40" height="40" viewBox="0 0 40 40" fill="none"
                                                 xmlns="http://www.w3.org/2000/svg">
                                                <circle cx="8.16667" cy="19.1673" r="4.16667"
                                                        transform="rotate(-90 8.16667 19.1673)" fill="#002335"/>
                                                <circle cx="32.8337" cy="19.1673" r="4.16667"
                                                        transform="rotate(-90 32.8337 19.1673)" fill="#002335"/>
                                                <circle cx="20.4997" cy="19.1673" r="4.16667"
                                                        transform="rotate(-90 20.4997 19.1673)" fill="#002335"/>
                                            </svg>
                                        </div>

                                        {
                                            showElements[index] ? (
                                                <div className={"consigneCardContentActionsContent"}>
                                                    <div className={"consigneCardContentActionsItems"}
                                                         onClick={() => handleZoomConsigne(data.consigne, index)}>
                                                        <svg width="21" height="20" viewBox="0 0 21 20" fill="none"
                                                             xmlns="http://www.w3.org/2000/svg">
                                                            <path
                                                                d="M2.11215 11.0474C1.73996 10.3991 1.73996 9.6023 2.11215 8.95404C4.07047 5.54313 7.20283 3.33398 10.7328 3.33398C14.2628 3.33398 17.3952 5.5431 19.3535 8.95397C19.7257 9.60222 19.7257 10.399 19.3535 11.0473C17.3952 14.4582 14.2628 16.6674 10.7328 16.6674C7.20282 16.6674 4.07048 14.4582 2.11215 11.0474Z"
                                                                stroke="#002335" strokeWidth="2"/>
                                                            <ellipse cx="10.7334" cy="10" rx="2.5" ry="2.5"
                                                                     stroke="#002335"
                                                                     strokeWidth="2"/>
                                                        </svg>
                                                        <span
                                                            className={"consigneCardContentActionsItemsName"}>Voir</span>
                                                    </div>
                                                    <div className={"consigneCardContentActionsItemsSeparateur"}></div>
                                                    <div className={"consigneCardContentActionsItems"}
                                                         onClick={() => handleUpdateconsigne(data.consigne, index)}>
                                                        <CrayonSvg/>
                                                        <span
                                                            className={"consigneCardContentActionsItemsName"}>Modifier</span>
                                                    </div>
                                                    <div className={"consigneCardContentActionsItemsSeparateur"}></div>
                                                    <div className={"consigneCardContentActionsItems"} onClick={() => {
                                                        setShowArchiveConsigne({
                                                            ...showArchiveConsigne,
                                                            isOpen: true,
                                                            idConsigne: data.consigne.id,
                                                            indexConsigne: index
                                                        })
                                                    }}>
                                                        <CorbeilleSvg/>
                                                        <span
                                                            className={"consigneCardContentActionsItemsName"}>Archiver</span>
                                                    </div>
                                                </div>
                                            ) : null
                                        }
                                    </div>
                                </div>


                                <div>
                                    {
                                        data.consigne.favoris === 1 ? (
                                            <BtnSvg svg={"ancrage"}
                                                    onClick={() => handleAddFavoris(data.consigne.id, data.consigne.favoris)}
                                                    width="28" height="38"/>
                                        ) : (
                                            <BtnSvg svg={"ancrage"}
                                                    onClick={() => handleAddFavoris(data.consigne.id, data.consigne.favoris)}
                                                    width="28" height="38" couleur={"#A8B0B3"}/>
                                        )
                                    }

                                </div>

                                <div className={"consigneCardContentText"}
                                     dangerouslySetInnerHTML={{__html: data.consigne.content}}/>

                                <div className={"consigneCardContentDate"}>
                                    {moment(data.consigne.created_at).format('DD MMMM YYYY')}
                                </div>

                                <div className={"consigneCardContentValidation"}>
                                    <div className={"consigneCardContentValidationItemsListe"}>
                                        <span className={"consigneCardContentValidationTitle"}>Validation</span>
                                        <div className={"consigneCardContentValidationItemsContent"}>
                                            {
                                                data.quart.map((quart, i) => (
                                                    <Checkbox id_input={quart}
                                                              onClick={(e) => handleUpdateQuart(quart, quart.statut, data.consigne.id)}
                                                              checked={quart.statut} label={quart.nom}/>
                                                ))
                                            }
                                        </div>

                                    </div>

                                </div>
                            </div>

                        </div>
                    ))
                }
            </div>

            {
                showArchiveConsigne.isOpen ? (
                    <ModalPrimary
                        textTitle={"Êtes-vous sur de vouloir archiver cette consignes ? "}
                        textComment={'Toutes les consignes archivées sont disponibles dans le menu "Archive".'}
                        textBtnValidate={"Archiver la consigne"}
                        textBtnCancel={"Revenir aux consignes"}
                        onCancel={() => setShowArchiveConsigne({
                            ...showArchiveConsigne,
                            isOpen: false,
                            idConsigne: '',
                            indexConsigne: ''
                        })}
                        onValidate={ArchiveConsigne}
                    />
                ) : null
            }
            {
                showModalEpingle ? (
                    <ModalPrimary
                        textTitle={"Vous ne pouvez pas épingler plus de 3 consignes !"}
                        textBtnCancel={"Revenir aux consignes"}
                        showValidateBtn={false}
                        onCancel={() => setShowModalEpingle(false)}
                    />
                ) : null
            }
        </div>
    );
});

export default WidgetConsignesContentHome;